import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  TravelTicketOption,
  type TravelTicketOptionConstructor,
} from './TravelTicketOption'

export const TravelTicketOptionConstructorFactory =
  Factory.Sync.makeFactory<TravelTicketOptionConstructor>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    purpose: Factory.each(() => faker.lorem.sentence()),
    status: Factory.each(() => faker.random.number({ min: 0, max: 5 })),
  })

export const TravelTicketOptionFactory = EntityFactory(
  TravelTicketOption,
  TravelTicketOptionConstructorFactory
)
